import { c as _c } from "react/compiler-runtime";
import { FeatherMail, FeatherMessageSquare, FeatherMonitor, FeatherTruck } from '@subframe/core';
import type { CanalComunicacaoCertificado } from '../../../types/certificadoAcessosTypes';
export const CANAL_LABEL: Record<CanalComunicacaoCertificado, string> = {
  WHATSAPP: 'WhatsApp',
  EMAIL: 'E-mail',
  RCS: 'RCS',
  CORREIOS: 'Correios (AR)',
  PLATAFORMA: 'Plataforma Arbitralis'
};
interface WhatsappGlyphProps {
  className?: string;
}
export function WhatsappGlyph(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.76.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01M12.05 20.15h-.01c-1.52 0-3.01-.41-4.31-1.18l-.31-.18-3.2.84.85-3.12-.2-.32a8.24 8.24 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.28.86 5.84 2.42a8.2 8.2 0 0 1 2.42 5.83c0 4.54-3.7 8.24-8.24 8.24M16.56 14.02c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43-.14-.01-.31-.01-.47-.01-.16 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
interface CanalIconeProps {
  canal: CanalComunicacaoCertificado;
  className?: string;
}
export function CanalIcone(t0) {
  const $ = _c(10);
  const {
    canal,
    className
  } = t0;
  if (canal === "WHATSAPP") {
    let t1;
    if ($[0] !== className) {
      t1 = <WhatsappGlyph className={className} />;
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (canal === "EMAIL") {
    let t1;
    if ($[2] !== className) {
      t1 = <FeatherMail className={className} />;
      $[2] = className;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (canal === "RCS") {
    let t1;
    if ($[4] !== className) {
      t1 = <FeatherMessageSquare className={className} />;
      $[4] = className;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  if (canal === "PLATAFORMA") {
    let t1;
    if ($[6] !== className) {
      t1 = <FeatherMonitor className={className} />;
      $[6] = className;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    return t1;
  }
  let t1;
  if ($[8] !== className) {
    t1 = <FeatherTruck className={className} />;
    $[8] = className;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}